/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkTimeAllocationResponse } from './WorkTimeAllocationResponse';
import {
    WorkTimeAllocationResponseFromJSON,
    WorkTimeAllocationResponseFromJSONTyped,
    WorkTimeAllocationResponseToJSON,
    WorkTimeAllocationResponseToJSONTyped,
} from './WorkTimeAllocationResponse';

/**
 * 
 * @export
 * @interface CounselorWorkTimeResponse
 */
export interface CounselorWorkTimeResponse {
    /**
     * 
     * @type {string}
     * @memberof CounselorWorkTimeResponse
     */
    counselorId: string;
    /**
     * 
     * @type {number}
     * @memberof CounselorWorkTimeResponse
     */
    weeklyHours: number;
    /**
     * 
     * @type {Array<WorkTimeAllocationResponse>}
     * @memberof CounselorWorkTimeResponse
     */
    allocations: Array<WorkTimeAllocationResponse>;
}

/**
 * Check if a given object implements the CounselorWorkTimeResponse interface.
 */
export function instanceOfCounselorWorkTimeResponse(value: object): value is CounselorWorkTimeResponse {
    if (!('counselorId' in value) || value['counselorId'] === undefined) return false;
    if (!('weeklyHours' in value) || value['weeklyHours'] === undefined) return false;
    if (!('allocations' in value) || value['allocations'] === undefined) return false;
    return true;
}

export function CounselorWorkTimeResponseFromJSON(json: any): CounselorWorkTimeResponse {
    return CounselorWorkTimeResponseFromJSONTyped(json, false);
}

export function CounselorWorkTimeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CounselorWorkTimeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'counselorId': json['counselorId'],
        'weeklyHours': json['weeklyHours'],
        'allocations': ((json['allocations'] as Array<any>).map(WorkTimeAllocationResponseFromJSON)),
    };
}

export function CounselorWorkTimeResponseToJSON(json: any): CounselorWorkTimeResponse {
    return CounselorWorkTimeResponseToJSONTyped(json, false);
}

export function CounselorWorkTimeResponseToJSONTyped(value?: CounselorWorkTimeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'counselorId': value['counselorId'],
        'weeklyHours': value['weeklyHours'],
        'allocations': ((value['allocations'] as Array<any>).map(WorkTimeAllocationResponseToJSON)),
    };
}

